export default "__VITE_ASSET__CxskLjQG__"